var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.976,
    height: 31.413,
    viewBox: "0 0 25.976 31.413",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10141",
    "data-name": "Grupo 10141",
    transform: "translate(-278 -835.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_1",
    "data-name": "Linha 1",
    x2: 7.378,
    y2: 10.33,
    transform: "translate(294.97 855.171)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_205",
    "data-name": "Elipse 205",
    transform: "translate(278 835.25)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.067,
    cy: 11.067,
    r: 11.067,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.067,
    cy: 11.067,
    r: 9.067,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.ad0d5951dce0cfa6b48831e6b2277368.svg";